import React from 'react';
import {Menu} from 'antd';
import {Link} from 'react-router-dom';

const items = [
    {
        key: 'Home',
        label: <Link to="/">首页</Link>,
    },
    {
        key: 'about',
        label: <Link to="/about">关于</Link>,
    },
    {
        key: 'Support',
        label: <Link to="/Support">支持</Link>,
    },
    {
        key: 'TestRedux',
        label: <Link to="/TestRedux">TestRedux</Link>,
    }, {
        key: 'Login',
        label: <Link to="/Login">Login</Link>,
    },
];

const Navbar = () => {
    return <Menu theme="dark" mode="horizontal" items={items} />;
};

export default Navbar;
